import {Validators} from "@angular/forms";
import {TurnkeyCostFormField} from "../types/tp-turnkey-cost-modal,types";

export const turnkeyCostFields: Array<TurnkeyCostFormField> = [
  {
    fieldName: 'date',
    label: 'Дата',
    type: 'date',
    validators: [Validators.required]
  },
  {
    fieldName: 'cost',
    label: 'Стоимость (руб)',
    type: 'number',
    inputType: 'number',
    validators: [Validators.required]
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    type: 'textarea'
  },
]
